<ng-container wp-isolated-query-space>
  <widget-wp-table [resource]="resource"
                   (resourceChanged)="onResourceChanged($event)"> </widget-wp-table>
</ng-container>
